// Front end javascript file
// you might want to have everything within one of these bad boys:
// window.addEventListener('load', (event) => { --> code here <-- });

// window.addEventListener('load', (event) => { 
addEventListener("DOMContentLoaded", (event) => {

 // Assigns tab index to menu buttons for accessibility
 let tabIndexable = document.querySelectorAll(".tabIndexableJS");
 let index        = 2 // Index starts at 2 as the mobile menu button is index 1

 tabIndexable.forEach((menu) => {
 //Selects both links and buttons, then combines into one elms variable 
 let elms = new Set([
   ...menu.querySelectorAll("a, button")
 ]);

  elms.forEach((elm) => {
   elm.tabIndex=(index);
   ++index
  });
 });


       //Code for navbar pickup
 if ( !SUPPORT_IntersectionObserver ) {

 } else {
  let navbarPlaceholder         = document.querySelector(".navbarPlaceholderJS");
  let navbarPlaceholderPosition = navbarPlaceholder.offsetTop
  let navbarHeightFixed         = -navbarPlaceholder.offsetHeight+"px";
  let navbarHeightRelative      = -navbarPlaceholder.offsetHeight+"px";
  let navbar                    = navbarPlaceholder.querySelector(".navbar");
  let navbarHeight              = navbar.getBoundingClientRect();
  let navbarAbove               = document.querySelector(".navbarAboveJS");


  navbarPlaceholder.style.height = navbarHeight.height+"px";

  // * 0.9 so the navStickIsPrevented state is changed just before
  // The navbar stick is triggered. Otherwise the margin is too small
  // and it doesn't work
  navbarPlaceholderPosition = navbarPlaceholderPosition*0.9+"px"
  navbarAbove.style.height = navbarPlaceholderPosition;

  // This observer is for the above element
  optionsAbove = {
   rootMargin: navbarHeightRelative
  };


  const navbarObsrvAbove = new IntersectionObserver(function(entries, observer) {
   entries.forEach(entry => {
    if(entry.isIntersecting) {
     preventNavbarStick(true);
    } else {
     preventNavbarStick(false);
    }
   });
  }, optionsAbove);

  navbarObsrvAbove.observe(navbarAbove);


  // Code for picking up the navbar
  optionsFixed = {
   rootMargin: navbarHeightFixed
  };

  optionsRelative = {
   rootMargin: navbarHeightRelative
  };
  // One observer for when it leaves the screen and one for when it enters
  // This is so they can different settings, making for a smoother transition
  // between stuck and un stuck
  const navbarObsrvFixed = new IntersectionObserver(function(entries, observer) {
   entries.forEach(entry => {
    if(entry.isIntersecting) {
     return;
    } else {
     if(navStickIsPrevented == false) {
      navbar.classList.add("stuck");
     }
    }
   });
  }, optionsFixed);

  const navbarObsrvRelative = new IntersectionObserver(function(entries, observer) {
   entries.forEach(entry => {
    if(entry.isIntersecting) {
     navbar.classList.remove("stuck");
    } else {
     return;
    }
   });
  }, optionsRelative);

  navbarObsrvFixed.observe(navbarPlaceholder);
  navbarObsrvRelative.observe(navbarPlaceholder);

 }


 // Toggles open and closed the mobile side menu, on click and keypress
 // Also handles button animations
 let mobileMenuBtn      = document.querySelector(".mobileMenuBtnJS");
 let mobileMenuClose    = document.querySelector(".mobileMenuCloseJS");
 let mobileMenuClickOff = document.querySelector(".MobileMenuClickOffJS");
 let mobileMenuSvg      = document.querySelector(".mobileMenuSvgJS");
 let mobileMenu         = document.querySelector(".mobileMenuJS");

 function toggleMobileNav() {
  mobileMenuSvg.classList.toggle("active");
  mobileMenu.classList.toggle("open");
  mobileMenuClickOff.classList.toggle("open");
  ariaExpandToggle(mobileMenuBtn);
 }

 mobileMenuBtn.onclick = function(e) {
  toggleMobileNav();
 };

 mobileMenuClose.onclick = function(e) {
  toggleMobileNav();
 };

 mobileMenuClickOff.onclick = function(e) {
  toggleMobileNav();
 };

 mobileMenuBtn.keypress = function(e) {
  let keyCode = e.keyCode;

  // Works with Enter or Space keys. See: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
  if (keyCode === 13 || keyCode === 32) {
   toggleMobileNav();
  } 
 }

 mobileMenuClose.keypress = function(e) {
  let keyCode = e.keyCode;

  // Works with Enter or Space keys. See: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
  if (keyCode === 13 || keyCode === 32) {
   toggleMobileNav();
  } 
 }

 mobileMenuClickOff.keypress = function(e) {
  let keyCode = e.keyCode;

  // Works with Enter or Space keys. See: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
  if (keyCode === 13 || keyCode === 32) {
   toggleMobileNav();
  } 
 }
});